export var UserStatus;
(function (UserStatus) {
    UserStatus["Verified"] = "VERIFIED";
    UserStatus["Declared"] = "DECLARED";
    UserStatus["Supervised"] = "SUPERVISED";
    UserStatus["SupervisedApprovalPending"] = "SUPERVISED_APPROVAL_PENDING";
    UserStatus["SupervisedApprovalDenied"] = "SUPERVISED_APPROVAL_DENIED";
    UserStatus["Unknown"] = "UNKNOWN";
    UserStatus["Empty"] = "EMPTY";
})(UserStatus || (UserStatus = {}));
export var AndroidDebugScenario;
(function (AndroidDebugScenario) {
    AndroidDebugScenario["Live"] = "LIVE";
    AndroidDebugScenario["Verified"] = "VERIFIED";
    AndroidDebugScenario["Declared"] = "DECLARED";
    AndroidDebugScenario["Supervised"] = "SUPERVISED";
    AndroidDebugScenario["SupervisedApprovalPending"] = "SUPERVISED_APPROVAL_PENDING";
    AndroidDebugScenario["SupervisedApprovalDenied"] = "SUPERVISED_APPROVAL_DENIED";
    AndroidDebugScenario["Unknown"] = "UNKNOWN";
    AndroidDebugScenario["NoSignal"] = "NO_SIGNAL";
    AndroidDebugScenario["NetworkError"] = "NETWORK_ERROR";
})(AndroidDebugScenario || (AndroidDebugScenario = {}));
export var AgeRangeDeclarationType;
(function (AgeRangeDeclarationType) {
    AgeRangeDeclarationType["SelfDeclared"] = "SELF_DECLARED";
    AgeRangeDeclarationType["GuardianDeclared"] = "GUARDIAN_DECLARED";
    AgeRangeDeclarationType["CheckedByOtherMethod"] = "CHECKED_BY_OTHER_METHOD";
    AgeRangeDeclarationType["GuardianCheckedByOtherMethod"] = "GUARDIAN_CHECKED_BY_OTHER_METHOD";
    AgeRangeDeclarationType["GovernmentIdChecked"] = "GOVERNMENT_ID_CHECKED";
    AgeRangeDeclarationType["GuardianGovernmentIdChecked"] = "GUARDIAN_GOVERNMENT_ID_CHECKED";
    AgeRangeDeclarationType["PaymentChecked"] = "PAYMENT_CHECKED";
    AgeRangeDeclarationType["GuardianPaymentChecked"] = "GUARDIAN_PAYMENT_CHECKED";
})(AgeRangeDeclarationType || (AgeRangeDeclarationType = {}));
export var ParentalControlType;
(function (ParentalControlType) {
    ParentalControlType["CommunicationLimits"] = "COMMUNICATION_LIMITS";
    ParentalControlType["SignificantAppChangeApprovalRequired"] = "SIGNIFICANT_APP_CHANGE_APPROVAL_REQUIRED";
})(ParentalControlType || (ParentalControlType = {}));
export var RegulatoryFeature;
(function (RegulatoryFeature) {
    RegulatoryFeature["DeclaredAgeRangeRequired"] = "DECLARED_AGE_RANGE_REQUIRED";
    RegulatoryFeature["SignificantAppChangeRequiresAdultNotification"] = "SIGNIFICANT_APP_CHANGE_REQUIRES_ADULT_NOTIFICATION";
    RegulatoryFeature["SignificantAppChangeRequiresParentalConsent"] = "SIGNIFICANT_APP_CHANGE_REQUIRES_PARENTAL_CONSENT";
})(RegulatoryFeature || (RegulatoryFeature = {}));
export var SignificantUpdateChoice;
(function (SignificantUpdateChoice) {
    SignificantUpdateChoice["Approval"] = "APPROVAL";
    SignificantUpdateChoice["Denial"] = "DENIAL";
})(SignificantUpdateChoice || (SignificantUpdateChoice = {}));
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["ApiNotAvailable"] = "API_NOT_AVAILABLE";
    ErrorCode["AppNotOwned"] = "APP_NOT_OWNED";
    ErrorCode["CannotBindToService"] = "CANNOT_BIND_TO_SERVICE";
    ErrorCode["ClientTransientError"] = "CLIENT_TRANSIENT_ERROR";
    ErrorCode["GooglePlayConsoleRequired"] = "GOOGLE_PLAY_CONSOLE_REQUIRED";
    ErrorCode["ImplementationUnavailable"] = "IMPLEMENTATION_UNAVAILABLE";
    ErrorCode["InternalError"] = "INTERNAL_ERROR";
    ErrorCode["IllegalAgeGates"] = "ILLEGAL_AGE_GATES";
    ErrorCode["InvalidSignificantUpdateRequest"] = "INVALID_SIGNIFICANT_UPDATE_REQUEST";
    ErrorCode["NetworkError"] = "NETWORK_ERROR";
    ErrorCode["PlayServicesNotFound"] = "PLAY_SERVICES_NOT_FOUND";
    ErrorCode["PlayServicesVersionOutdated"] = "PLAY_SERVICES_VERSION_OUTDATED";
    ErrorCode["PlayStoreNotFound"] = "PLAY_STORE_NOT_FOUND";
    ErrorCode["PlayStoreVersionOutdated"] = "PLAY_STORE_VERSION_OUTDATED";
    ErrorCode["PresentationContextUnavailable"] = "PRESENTATION_CONTEXT_UNAVAILABLE";
    ErrorCode["RequestTimedOut"] = "REQUEST_TIMED_OUT";
    ErrorCode["ResponseUnavailable"] = "RESPONSE_UNAVAILABLE";
    ErrorCode["SdkVersionOutdated"] = "SDK_VERSION_OUTDATED";
    ErrorCode["UnsupportedPlatform"] = "UNSUPPORTED_PLATFORM";
    ErrorCode["Unknown"] = "UNKNOWN";
})(ErrorCode || (ErrorCode = {}));
